import { render, staticRenderFns } from "./PerformanceSecao.vue?vue&type=template&id=726176e5&scoped=true&"
import script from "./PerformanceSecao.vue?vue&type=script&lang=js&"
export * from "./PerformanceSecao.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceSecao.vue?vue&type=style&index=0&id=726176e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726176e5",
  null
  
)

export default component.exports